import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RequestHeaderHandler } from 'utils/RequestHeaderHandler'

export const categoryApiRedux = createApi({
	reducerPath: 'categoryApiRedux',
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BASE_URL,
		prepareHeaders: (headers, { getState }) => {
			return RequestHeaderHandler(headers)
		}
	}),
	endpoints: builder => ({
		getAllCategoriesApi: builder.query({
			query: () => {
				return {
					url:
						process.env.REACT_APP_USE_CASE === 'Project'
							? `category?useCase=Project`
							: `category?useCase=Course`
				}
			},
			transformResponse: response => response?.data || []
		}),
		getCategoriesWithProjectsApi: builder.query({
			query: () => {
				return {
					url: `category/getCategoriesWithProjects`
				}
			},
			transformResponse: response => response?.data || []
		})
	}),
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true
})
export const {
	useGetAllCategoriesApiQuery,
	useGetCategoriesWithProjectsApiQuery,
	useLazyGetCategoriesWithProjectsApiQuery
} = categoryApiRedux
